import { FaExternalLinkAlt  } from "react-icons/fa";

const FooterComponent = () => {

  return(
    <footer class="text-center">
      <p>All Rights Reserved | Made by &#169; <a href="https://github.com/kimanicharles911/" target="_blank" rel="noopener noreferrer">Charles</a> <FaExternalLinkAlt /></p>
    </footer>
  );
};
export default FooterComponent;